var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"no-margins"},[_c('ActionButton',{staticClass:"mt-4",attrs:{"actionIcon":"$sl-password-type"},on:{"click":function($event){return _vm.doPasswordLogin()}}},[_vm._v(_vm._s(_vm.buttonText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }